import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import {
  createCategory,
  editCategory,
  getCategoriesByPage,
  getCategory,
} from '../../ApiServices/CategoriesService';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [] },
  loading: false,
  error: null,
  message: null,
  selectedValue: null,
  rowsPerPage: 10,
  pageNo: 0,
  filter: {},
};

const categorySlice = createSlice({
  name: 'category',
  initialState: initialState,
  reducers: {
    clearCategoryState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
      state.filter = initialState.filter;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategories.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchCategories.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchCategoryById.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = action?.payload?.data;
    });
    builder.addCase(fetchCategoryById.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.error = action?.payload?.data;
    });
  },
});

export const categoryState = (state: RootState) => state?.category;
export const { clearCategoryState } = categorySlice.actions;
export default categorySlice.reducer;

export const fetchCategories = createAsyncThunk(
  'category/fetchCategories',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_CATEGORIES') }));
      return fulfillWithValue(await getCategoriesByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchCategoryById = createAsyncThunk(
  'category/fetchCategoryById',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_CATEGORIES_DETAILS') }));
      return fulfillWithValue(await getCategory(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const addCategory = createAsyncThunk(
  'category/addCategory',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_CATEGORY_DETAILS') }));
      let response: any = await createCategory(payload);
      // return await handleResponse(
      //   response,
      //   fulfillWithValue,
      //   rejectWithValue,
      //   dispatch
      // );
      if (response?.status === 200 || response === 200) {
        dispatch(showSuccessSnackbar({ message: t('CATEGORY_ADDED_SUCCESS') }));
      } else {
        dispatch(showErrorSnackbar({ message: t('CATEGORY_ADDITION_FAIL') }));
      }
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const modifyCategory = createAsyncThunk(
  'category/modifyCategory',
  async (payload: any, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      dispatch(showLoader({ message: t('UPDATE_CATEGORY_DETAILS') }));
      let response: any = await editCategory(payload);
      // return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
      //let response: any = await getCategoriesByPage(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(
          showSuccessSnackbar({ message: t('CATEGORY_UPDATE_SUCCESS') })
        );
      } else {
        dispatch(showErrorSnackbar({ message: t('CATEGORY_UPDATE_FAIL') }));
      }
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const downloadCategories = createAsyncThunk(
  'category/downloadCategories',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('DOWNLOADING_CATEGORIES') }));
      let response: any = await getCategoriesByPage(payload);
      if (response === 200)
        dispatch(showSuccessSnackbar({ message: t('DOWNLOAD_SUCCESS') }));
      else dispatch(showErrorSnackbar({ message: t('DOWNLOAD_FAILS') }));
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
